import { Api } from 'utils';

class DiscountService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/discounts/get',params),
		create: async (params?: any) => Api.createResponse('admin/discounts/create',params),
		update: async (params?: any) => Api.createResponse('admin/discounts/update',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/discounts/change-status',params),
		delete: async (params?: any) => Api.createResponse('admin/discounts/delete',params),
		bulkDelete: async (params?: any) => Api.createResponse('admin/discounts/bulk-delete',params),
		usageDetails: async (params?: any) => Api.createResponse('admin/discounts/usage-details',params),

		getDiscountDefault: async (params?: any) => Api.createResponse('admin/discounts/discount-default',params),
		createDiscountDefault: async (params?: any) => Api.createResponse('admin/discounts/discount-default-create',params),
	}

}

export default DiscountService;